import { Trans } from "@lingui/react/macro";
import React from "react";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import * as styles from "./CallOurReservationTeam.module.scss";

type Props = {
  className?: string;
  prefixOr?: boolean;
};

const CallOurReservationTeam: React.FC<Props> = ({
  className,
  prefixOr = false
}) => {
  const geolocation = useGeolocation();
  const phoneNumber = geolocation.phone;
  const phoneNumberComponent = (
    <strong className={styles.phoneNumber}>
      <a
        href={`tel:${phoneNumber}`}
        aria-label={`call ${phoneNumber}`}
        data-content-piece="phone"
      >
        {phoneNumber}
      </a>
    </strong>
  );

  return (
    <div className={className}>
      {prefixOr ? (
        <Trans id="or-call-our-reservation-team">
          or call our Reservation Team {phoneNumberComponent}
          <br />
          or contact your Travel Advisor
        </Trans>
      ) : (
        <Trans id="call-our-reservation-team">
          Call our Reservation Team {phoneNumberComponent}
          <br />
          or contact your Travel Advisor
        </Trans>
      )}
    </div>
  );
};

export default CallOurReservationTeam;
